<template>
  <Transition name="fade">
    <div class="bottom-bar" :class="{'white-bg':isBackTop}" v-if="isBackTop">
<!--      <div class="left" v-if="route.name === 'Home'" @click="router.push('/searchResult?searchTerm=&parameterValues=')">-->
<!--        <img class="dynamic-left-vector" src="@/assets/images/left.png" alt="">-->
<!--        <span>浏览设计数据库</span>-->
<!--      </div>-->

      <div class="center">
        <img class="dynamic-up-vector" src="@/assets/images/up.png" alt="">
        <span @click="backTop">回到顶部</span>
      </div>
    </div>

    <div class="bottom-bar" v-else>
      <div class="left" v-if="route.name === 'Browse'" @click="router.push('/home')">
        <img class="dynamic-left-vector" src="@/assets/images/left.png" alt="">
        <span>返回首页</span>
      </div>

      <div class="center">
        <img class="dynamic-down-vector" src="@/assets/images/down.png" alt="">
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { addEvent } from '@/utils'

const route = useRoute()
const router = useRouter()

const isBackTop = ref(false)

let timer = null
let isTop = true
onMounted(() => {
  // const clientHeight = document.documentElement.clientHeight
  addEvent(window, 'scroll', function () {
    const osTop = document.documentElement.scrollTop || document.body.scrollTop
    if (osTop >= 300) {
      isBackTop.value = true
    } else {
      isBackTop.value = false
    }

    if (!isTop) {
      clearInterval(timer)
    }

    isTop = false
  })
})

function backTop () {
  timer = setInterval(function () {
    const osTop = document.documentElement.scrollTop || document.body.scrollTop
    const speed = Math.floor(-osTop / 6)

    document.documentElement.scrollTop = document.body.scrollTop = osTop + speed

    isTop = true

    if (osTop === 0) {
      clearInterval(timer)
    }
  }, 30)
}
</script>

<style lang="scss" scoped>
.bottom-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 80px;
  font-size: 20px;
  font-weight: 600;
  position: fixed;
  z-index: 10;
  bottom: 0;

  &.white-bg {
    background: rgba(225, 225, 225, .7);
  }

  .dynamic-up-vector, .dynamic-left-vector {
    margin-right: 10px;
  }

  .left {
    position: absolute;
    left: 62px;
    cursor: pointer;

    span {
      font-family: 'NotoSerifSC', system-ui;
    }
  }

  .center {
    span {
      cursor: pointer;
      font-family: 'NotoSerifSC', system-ui;
    }
  }
}
</style>
